import { render } from "./ImportationUsager.vue?vue&type=template&id=62229914&ts=true"
import script from "./ImportationUsager.vue?vue&type=script&lang=ts"
export * from "./ImportationUsager.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__